import {  Navigate } from "react-router";

import { PageLoader } from "src/components/page/loading/PageLoader";
import { usePermissions } from "src/hooks";
import { isEnabled } from "src/utils/permission.utils";

export function LoginRedirectPage() {
  const { data: permissions } = usePermissions();

  if(!permissions) return <PageLoader />;
  if(isEnabled(permissions?.users.userAdmin)) return <Navigate to="/users" />;
  return <Navigate to="/cases" />;

 
}
